import type { UiStrings } from "../types";

export const ja: UiStrings = {
  nav: {
    category: "カテゴリー",
    forYourWork: "お仕事に役立つツール",
    searchPlaceholder: "300以上のツールを検索...",
    heroPlaceholder: "何をお探しですか?",
  },
  trustBadges: {
    noLogin: "ツールの利用にログイン不要",
    freeUsesDaily: "1日10回までお試し",
    filesNeverStored: "ファイルは保存されません",
    worksAnyDevice: "どのデバイスでも使用可能",
    worksWhenAiBlocked: "会社のAIポリシーに関係なくご利用いただけます",
    availableInLanguages: "複数の言語に対応",
  },
  common: {
    backToHome: "ホームに戻る",
    home: "ホーム",
    signIn: "サインイン",
    account: "アカウント",
    contact: "お問い合わせ",
    blog: "ブログ",
    shareThisTool: "このツールを共有",
    download: "ダウンロード",
    copy: "コピー",
    copied: "コピーしました",
  },
  footer: {
    tagline: "オールインワンのオンライン生産性プラットフォーム。日常業務に役立つ300以上のプロフェッショナルツール、プレミアムアプリ、ワークフロー製品。",
    company: "会社概要",
    about: "私たちについて",
    blog: "ブログ",
    contact: "お問い合わせ",
    pricing: "料金",
    privacyPolicy: "プライバシーポリシー",
    termsOfService: "利用規約",
    allTools: "すべてのツール",
    allRightsReserved: "全著作権所有。",
  },
  contact: {
    title: "お問い合わせ",
    subtitle: "ご質問やご意見、不具合など、お気軽にお問い合わせください。",
    email: "メールアドレス",
    responseTime: "返信までの目安",
    responseTimeValue: "通常1〜2営業日以内にご返信いたします。",
    sendEmail: "メールを送る",
    billingNote: "お支払いに関するお問い合わせの際は、アカウントに登録されているメールアドレスをご記載ください。",
    whoWeAreTitle: "FreeDailyProを運営しているのは",
    whoWeAreBody: "FreeDailyProはDreamUSA LLCという小さな独立系ソフトウェア企業が運営しています。大規模なサポートチームは存在せず、メールを読んで返信する人物はツールを作成・保守する人物と同一です。そのため、返信に1〜2日かかることがあります。",
    whatWeSupportTitle: "サポート内容",
    whatWeSupportBody: "300以上のツールの不具合報告、機能リクエスト、請求・サブスクリプションに関する質問（解約や返金を含む）、アカウントやログインの問題、ご意見全般に対応します。ツールが正しくない結果を出した場合は、ファイル形式と何が問題だったかを教えていただけると、より早く修正できます。",
  },
  home: {
    heroTitleLine1: "あらゆるプロの作業を。",
    heroTitleLine2: "ひとつのブラウザプラットフォーム",
    heroSubtitle: "ツールを使う、ワークフローを実行する、APIとMCPで作る。または、私たちに開発を任せる。",
    localSignalUsedTitle: "このデバイスで使用済み",
    localSignalTryTitle: "こちらをお試しください",
    localSignalBadge: "ローカル \u00b7 ネットワーク不要",
    localSignalUsedDesc: "このデバイスで使用したツール \u2014 ブラウザの外に出たものは一つもありません",
    localSignalTryDesc: "このデバイスではまだ未使用 \u2014 すべてこのブラウザ内で実行されます",
    corporateSafeTitle: "企業でも安心",
    corporateSafeSubtitle: "会社のAIポリシーがどのようなものでも、FreeDailyProは変わらずご利用いただけます",
    corporateSafeBlockedTitle: "完全にブロック",
    corporateSafeBlockedDesc: "ネットワーク上であらゆる種類のAIツールが許可されていない場合でも、FreeDailyProのすべてのツールは問題なく動作します \u2014 サーバーへのアップロードは一切ありません。",
    corporateSafeGovernedTitle: "承認済みツールのみ許可",
    corporateSafeGovernedDesc: "承認・審査済みのツールのみAI利用が許可されている場合。ここでは承認は不要です \u2014 審査すべき外部サーバーへの通信自体が存在しません。",
    corporateSafeOpenTitle: "制限なし",
    corporateSafeOpenDesc: "仕事に役立つものを自由にお使いください。アップロードや待機が不要な分、FreeDailyProはただシンプルに高速です。",
    corporateSafeCta: "企業向け詳細情報を見る \u2192",
    exploreToolkitTitle: "ツール一覧を見る",
    exploreToolkitSubtitle: "{catCount}のカテゴリーに300以上のツール \u2014 選ぶか、検索してください。",
    forYourWorkTitle: "あなたの実際の仕事に合わせて",
    forYourWorkSubtitle: "同じプロ向けツールを、実際の職種別に整理しました",
    exploreTools: "ツールを見る",
    seeAllRoles: "{count}の職種をすべて見る \u2192",
    blogTitle: "ブログから",
    viewAllPosts: "すべての記事を見る",
    faqTitle: "ご質問がありますか? よくある質問をご確認ください",
    faqMoreLink: "他の回答をお探しですか? すべてのFAQを見る \u2192",
    toolkitProseTitle: "単発の作業だけでなく、日々の仕事のために作られたプロ向けツール集",
    closingCtaTitle: "ショートカットの追加をお忘れなく",
    closingCtaDesc: "一度追加すれば、いつでもワンクリックでアクセス可能 \u2014 デスクトップショートカットをインストールするか、スマートフォンのホーム画面に追加すると、FreeDailyProがネイティブアプリのように開き、ブラウザのタブを探す手間がありません。",
    categoriesLabel: "{count}件のカテゴリー \u2192",
    viewAllCategoriesLabel: "{count}件のカテゴリーをすべて見る \u2192",
    yourFavorites: "お気に入り",
    recentlyUsed: "最近使用したツール",
    toolkitProsePara1: "FreeDailyProは、PDF編集、画像変換、動画トリミング、音声クリーンアップ、テキスト整形、多数の計算ツールなど、300以上の日常ツールを一箇所にまとめています。タスクごとに別のサイトを行き来する必要はありません。ほとんどのツールは登録不要で、ファイル系ツールには1日10回の無料利用が含まれます。",
    toolkitProsePara2: "すべてのツールは完全にブラウザ内で動作します。PDFを圧縮したり写真の背景を削除したりしても、そのファイルがデバイスの外に出ることは一切ありません \u2014 アップロードされず、サーバーで処理されず、一時的にでもどこにも保存されません。これは制限ではなく、設計そのものです。より速い処理結果と、機密ファイルでも安心できる仕組みです。",
    toolkitProsePara3: "このローカルファーストの仕組みにより、個人のノートPCでも、制限のかかった業務用マシンでも、厳格なAI利用ポリシーのあるネットワークでも、FreeDailyProは同じように動作します \u2014 情報システム部門が評価すべき外部サーバーへの通信自体が存在しないためです。",
    toolkitProsePara4: "レポート用にPDFを結合する、掲載用に画像をリサイズする、SNS用に動画クリップをトリミングする、住宅ローンや税金をさっと計算する \u2014 どんな場面でも、FreeDailyProは必要なときにたまたま思い出すツールではなく、毎日使うツールとして作られています。",
    heroLaneToolsTitle: "個別タスク向けのプロ仕様ツール",
    heroLaneToolsDesc: "PDF、画像、動画など -- ブラウザ内で一つの操作だけで完結。",
    heroLaneToolsCta: "ツールを見る",
    heroLanePremiumTitle: "大きな作業向けのプレミアムアプリ",
    heroLanePremiumDesc: "複数ステップのアプリ：文書、フォーム、プランナー、印刷、イベント書類。",
    heroLanePremiumCta: "アプリを見る",
    heroLaneWorkflowTitle: "ワークフロー製品",
    heroLaneWorkflowDesc: "Book Writing Toolbox、Event Suiteなど -- 複数のステップで一つの成果物に。",
    heroLaneWorkflowCta: "ワークフロー製品を見る",
    heroLaneApiTitle: "APIとMCP",
    heroLaneApiDesc: "自分のコードやAIエージェントから同じツールを呼び出せます。",
    heroLaneApiCta: "開発者ページを開く",
    heroLaneCustomTitle: "カスタムソフトウェア",
    heroLaneCustomDesc: "必要なものをお聞かせください。開発は一度きりの費用で、その後は少額の月額利用料のみです。",
    heroLaneCustomCta: "開発を依頼する",
  },
  install: {
    desktopTitle: "デスクトップショートカット",
    desktopSubtitle: "ワンクリックで即座に開く",
    mobileTitle: "モバイルアプリ",
    mobileSubtitle: "ホーム画面に追加",
    addToHomeScreenTitle: "FreeDailyProをホーム画面に追加",
    iosInstructions: "Safariの共有アイコンをタップし、「ホーム画面に追加」を選択してください。",
    genericInstructions: "ブラウザのメニューを開き、「ホーム画面に追加」または「アプリをインストール」を探してください。",
    desktopUnavailableTitle: "このブラウザではワンクリックインストールをご利用いただけません",
    desktopUnavailableDesc: "このページをブックマークするか、アドレスバーのアイコンをデスクトップにドラッグすることもできます。",
    desktopSuccess: "ショートカットを作成しました！FreeDailyProのアイコンをお探しください。",
    mobileSuccess: "追加しました！ホーム画面のFreeDailyProアイコンをお探しください。",
  },
  toolPage: {
    proBadge: "Pro",
    usesRemainingToday: "本日のお試し利用残り{count}回",
    whatThisToolDoes: "このツールについて",
    proTips: "活用のヒント",
    continueWith: "次はこちら",
    moreFromCategory: "このカテゴリーの他のツール",
  },
  usageStrip: {
    freeUsesPerDay: "お試し：1日{limit}回利用可能",
    remainingToday: "本日残り{count}回",
    dayPassLabel: "広告なし・無制限利用、1日パス $1",
    monthlyLabel: "広告なし・無制限利用、月額パス $4.99",
    quickBuy: "今すぐ購入",
  },
  platformsBanner: {
    title: "このAPIが実際に公開されている場所",
    subtitle: "「近日公開」ではありません -- 今すぐ購読・接続できる、実際に稼働しているリストです。",
    postmanDetail: "すぐに使えるリクエスト、完全ドキュメント付き",
    rapidApiDetail: "Rapidのマーケットプレイスで従量課金制のサブスクリプション",
    mcpRegistryDetail: "com.freedailypro/toolsとして正式登録、{mcp}ツール、1つのエンドポイント",
  },
  pricingBanner: {
    title: "透明な料金体系",
    subtitle: "隠れた段階や予期しない制限はありません -- 各プランの費用と内容を明確に。",
    toolPricingTitle: "従量制ツール料金",
    apiPricingTitle: "従量制API・MCP料金",
    freeLabel: "お試し",
    freeToolDetail: "Professional Toolsは1日10回、Premium Applicationsは1日2回",
    dayPassDetail: "$1/日 -- 広告なし・無制限利用",
    monthlyDetail: "$4.99/月 -- 広告なし・無制限利用",
    monthlySavingsNote: "1か月にデイパスを5回買うより お得",
    freeApiDetail: "月ど20,000回まで",
    premiumDetail: "$24/月 -- 200,000回",
    ultraDetail: "$69/月 -- 750,000回",
    megaDetail: "$129/月 -- 2,000,000回 + 優先処理",
  },
  apiMcpBanner: {
    title: "API・MCP対応開始",
    description: "200以上のツールを自前のコードから直接呼び出したり、MCP経由でAIエージェントを接続したりできます -- ブラウザだけでは足りないときのための、サーバー側での同じツールです。",
    oneKey: "すべてに1つのキー",
    restApiMcp: "REST API + MCP",
    anyLanguage: "どの言語でも、どのサーバーでも",
    cta: "API・MCPを見る",
  },
  premiumApps: {
    title: "プレミアムアプリ",
    subtitle: "単一の操作ではなく、本格的な複数ステップのアプリケーションです。単独でのインストールも可能です。",
    seeAll: "すべてのプレミアムアプリを見る",
  },
  googleDrive: {
    openFromGoogle: "Google ドライブから開く",
    saveToGoogle: "Google ドライブに保存",
    signingIn: "Google のログイン画面を開いています...",
    fetching: "Google ドライブからファイルを取得しています...",
    saving: "Google ドライブに保存しています...",
    saved: "Google ドライブに保存しました",
    viewInDrive: "ドライブで表示",
    popupBlocked: "ブラウザが Google のログインウィンドウをブロックしました。このサイトのポップアップを許可してから、もう一度お試しください。",
    cancelled: "Google のログインが完了前に閉じられました。ファイルは開かれず、保存もされていません。",
    denied: "Google ドライブへのアクセスが許可されなかったため、何も開かれず保存もされていません。もう一度お試しいただき、選択したファイルへのアクセスを許可してください。",
    loadFailed: "Google に接続できませんでした。接続やコンテンツブロッカーを確認して、もう一度お試しください。",
    network: "Google ドライブとの接続が切れました。もう一度お試しください。",
    tooLarge: "このファイルはブラウザで開くには大きすぎます。",
    api: "Google ドライブで処理を完了できませんでした。もう一度お試しください。",
    largeFile: "このファイルは 50 MB を超えています。時間がかかるか、ブラウザのメモリが不足する場合があります。",
    privacyNote: "ファイルはお使いのブラウザと Google の間でやり取りされ、当社のサーバーには送信されません。",
  },
};
